module.exports = __webpack_public_path__ + "static/media/selector.711e23f4.svg";